import { Directive } from '@angular/core';
import { InputNumber } from 'primeng/inputnumber';

@Directive({
  selector: 'p-inputNumber[appTwoDigitNumber]'
})
export class TwoDigitNumberDirective {
  constructor(inputNumber: InputNumber) {
    const getOptions = inputNumber.getOptions.bind(inputNumber);

    inputNumber.getOptions = () => ({
      ...getOptions(),
      minimumIntegerDigits: 2
    });
  }
}
